import Vue from 'vue';
import Router from 'vue-router';
import store from './store';
// import Home from './views/Home.vue';

Vue.use(Router);

// for public
const ifNotAuthenticated = (to, from, next) => {
  if (!store.getters.tokenscr) {
    next();
    return;
  }
  next('/home');
};
// for user
const ifAuthenticated = (to, from, next) => {
  if (store.getters.tokenscr) {
    next();
    return;
  }
  next('/login');
};
// for user
const ifAuthenticatedUser = (to, from, next) => {
  if (store.getters.tokenscr) {
    if (store.getters.userrole === 'mahasiswa') {
      next();
      return;
    } else {
      next('/home');
    }
  }
  next('/login');
};
// for klian
const ifAuthenticatedDosen = (to, from, next) => {
  if (store.getters.tokenscr) {
    if (store.getters.userrole === 'dosen') {
      next();
      return;
    } else {
      next('/home');
    }
  }
  next('/login');
};
// for jurusan
const ifAuthenticatedJur = (to, from, next) => {
  if (store.getters.tokenscr) {
    if (store.getters.userrole === 'jurusan') {
      next();
      return;
    } else {
      next('/home');
    }
  }
  next('/login');
};
// for admin
const ifAuthenticatedAdmin = (to, from, next) => {
  if (store.getters.tokenscr) {
    if (store.getters.userrole === 'admin') {
      next();
      return;
    } else {
      next('/home');
    }
  }
  next('/login');
};

export default new Router({
  mode: 'hash',
  base: process.env.BASE_URL,
  routes: [
    {
      path: '/',
      name: 'Landing',
      component: () => import('./views/Landing.vue'),
    },
    {
      path: '/check',
      name: 'Check',
      component: () => import('./views/Check.vue'),
    },
    {
      path: '/verifikasi/:kodesurat',
      name: 'Verifikasi',
      props: true,
      component: () => import('./views/Verifikasi.vue'),
    },
    {
      path: '/contact',
      name: 'Contact',
      component: () => import('./views/Contact.vue'),
    },
    {
      path: '/home',
      name: 'Home',
      component: () => import('./views/Home.vue'),
      beforeEnter: ifAuthenticated,
    },
    {
      path: '/login',
      name: 'Login',
      component: () => import('./views/Login.vue'),
      beforeEnter: ifNotAuthenticated,
    },
    {
      path: '/help',
      name: 'Help',
      component: () => import('./views/Help.vue'),
    },
    {
      path: '/beasiswa',
      name: 'SuratGuest',
      component: () => import('./views/guest/Surat.vue'),
      beforeEnter: ifAuthenticatedUser,
    },
    {
      path: '/dosen/surat',
      name: 'SuratDosen',
      component: () => import('./views/dosen/Surat.vue'),
      beforeEnter: ifAuthenticatedDosen,
    },
    {
      path: '/changepassword',
      name: 'Changepassword',
      component: () => import('./views/Changepassword.vue'),
      beforeEnter: ifAuthenticated,
    },
    {
      path: '/admin/penduduk',
      name: 'PendudukAdmin',
      component: () => import('./views/admin/Penduduk.vue'),
      beforeEnter: ifAuthenticatedAdmin,
    },
    {
      path: '/admin/beasiswa',
      name: 'SuratAdmin',
      component: () => import('./views/admin/Surat.vue'),
      beforeEnter: ifAuthenticatedAdmin,
    },
    {
      path: '/jurusan/beasiswa',
      name: 'BeasiswaJur',
      component: () => import('./views/jurusan/Beasiswa.vue'),
      beforeEnter: ifAuthenticatedJur,
    },
    {
      path: '/mahasiswa/beasiswa/:kodesurat',
      name: 'SuratDetailMhs',
      props: true,
      component: () => import('./views/guest/Suratdetail.vue'),
      beforeEnter: ifAuthenticatedUser,
    },
    {
      path: '/admin/beasiswa/:kodesurat',
      name: 'SuratDetailAdmin',
      props: true,
      component: () => import('./views/admin/Suratdetail.vue'),
      beforeEnter: ifAuthenticatedAdmin,
    },
    {
      path: '/jurusan/beasiswa/:kodesurat',
      name: 'BeasiswaDetailJur',
      props: true,
      component: () => import('./views/jurusan/Beasiswadetail.vue'),
      beforeEnter: ifAuthenticatedJur,
    },
    {
      path: '/dosen/surat/:kodesurat',
      name: 'SuratDetailDosen',
      props: true,
      component: () => import('./views/dosen/Suratdetail.vue'),
      beforeEnter: ifAuthenticatedDosen,
    },
    {
      path: '/admin/jenissurat',
      name: 'JenissuratAdmin',
      component: () => import('./views/admin/Jenissurat.vue'),
      beforeEnter: ifAuthenticatedAdmin,
    },
    {
      path: '/admin/jeniskerja',
      name: 'JeniskerjaAdmin',
      component: () => import('./views/admin/Jeniskerja.vue'),
      beforeEnter: ifAuthenticatedAdmin,
    },
    {
      path: '/admin/kodepos',
      name: 'KodeposAdmin',
      component: () => import('./views/admin/Kodepos.vue'),
      beforeEnter: ifAuthenticatedAdmin,
    },
    {
      path: '/admin/banjar',
      name: 'BanjarAdmin',
      component: () => import('./views/admin/Banjar.vue'),
      beforeEnter: ifAuthenticatedAdmin,
    },
    {
      path: '/admin/klianbanjar',
      name: 'KlianbanjarAdmin',
      component: () => import('./views/admin/Klianbanjar.vue'),
      beforeEnter: ifAuthenticatedAdmin,
    },
    {
      path: '/admin/pendudukdetail',
      name: 'PendudukdetailAdmin',
      component: () => import('./views/admin/Pendudukdetail.vue'),
      beforeEnter: ifAuthenticatedAdmin,
    },
    {
      path: '/admin/setting',
      name: 'SettingAdmin',
      component: () => import('./views/admin/Setting.vue'),
      beforeEnter: ifAuthenticatedAdmin,
    },
    {
      path: '*',
      name: 'Notfound',
      component: () => import('./views/Notfound.vue'),
    },
  ],
});
